import { render, staticRenderFns } from "./Operational.Integration.DuasRodas.vue?vue&type=template&id=5f813014&scoped=true"
import script from "./Operational.Integration.DuasRodas.vue?vue&type=script&lang=js"
export * from "./Operational.Integration.DuasRodas.vue?vue&type=script&lang=js"
import style0 from "./Operational.Integration.DuasRodas.vue?vue&type=style&index=0&id=5f813014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f813014",
  null
  
)

export default component.exports